<template>
	<!-- заместители и дуалы -->
	<div ng-if="overlayController" class="windowOverlay" id="manageSitterAndDuals" ng-controller="overlayController">
		<div class="darkener clickable" clickable="closeOverlay()"></div>
		<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="774">
			<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
				<div class="inWindowPopupHeader">
					<h4 translate="" options="Settings.SittersAndDuals.Overlay.Headline" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Заместители и дуалы</span></h4>
					<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
					<a class="closeOverlay clickable" clickable="closeOverlay()" translate=""><span>Закрыть</span></a>
				</div>
				<div class="inWindowPopupContent">
					<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
						<div>
							<div ng-if="!isDual" translate=""><span>В лобби ты можешь назначить заместителей и дуалов для своего персонажа в этом игровом мире Дуал – это игрок, не имеющий своего персонажа в этом мире, который помогает тебе повысить общее время онлайна персонажа. Заместитель обладает меньшими правами. В его задачи входит присмотр за твоим персонажем тогда, когда у тебя мало времени для игры.</span></div>
							<!-- ngIf: isDual -->
							<div>
								<div class="buttonFooter">
									<button clickable="openLobby();" class="clickable">
										<div class="content">
											<span ng-transclude="" class="innerText">
												<span ng-if="!isDual" translate=""><span>Управление замещением и дуалами</span></span>
												<!-- ngIf: isDual -->
											</span>
											<!-- ngIf: price > 0 || forceGoldUsage -->
											<!-- ngIf: price == -1 && !forceGoldUsage -->
											<div class="animationOverlay"></div>
											<i class="checkmark action_check_small_flat_white"></i>
											<i class="checkmark action_check_small_flat_black"></i>
											<i class="checkmark action_check_small_flat_red"></i>
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){},
	components: {},
}
</script>